import { localContentConfig } from '../../../config';
import { http } from '../../axios';
import { CreditSummaryOut } from '../../../store/apiLibx';

export const fetchYourTitlesCreditsSummary = () => {
    return http.get<CreditSummaryOut>(localContentConfig().endpointCreditSummary).then(response => response.data);
};
